import { Decimal } from 'decimal.js';

// fix 0.3 / 0.1 = 2.9999999999999996
export function safeDiv(x: number, y: number) {
	return Decimal.div(x, y).toNumber();
}
